import React from 'react';

const OriginSection = () => {
  return (
    <section id="origin" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-24">
          <p className="text-emerald-700 text-sm font-medium tracking-widest uppercase mb-6">Production Region</p>
          <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-6 tracking-tight">
            Northern Kazakhstan
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-20 items-center">
          <div className="order-2 md:order-1 space-y-8">
            <p className="text-xl text-gray-600 leading-relaxed font-light">
              Northern Kazakhstan is one of the key agricultural regions in Eurasia, recognized for its large-scale production of grains and oilseeds.
            </p>
            
            <p className="text-xl text-gray-600 leading-relaxed font-light">
              The region benefits from favorable climate conditions, fertile soil, and modern agricultural infrastructure.
            </p>

            <div className="pt-8 space-y-5">
              <div className="flex items-start space-x-4">
                <div className="w-1.5 h-1.5 bg-emerald-700 rounded-full mt-3"></div>
                <p className="text-lg text-gray-700 font-light">Major agricultural production region in Eurasia</p>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-1.5 h-1.5 bg-emerald-700 rounded-full mt-3"></div>
                <p className="text-lg text-gray-700 font-light">Favorable climate and fertile soil conditions</p>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-1.5 h-1.5 bg-emerald-700 rounded-full mt-3"></div>
                <p className="text-lg text-gray-700 font-light">Modern farming practices and infrastructure</p>
              </div>
            </div>
          </div>

          <div className="order-1 md:order-2">
            <img
              src="https://images.unsplash.com/photo-1666011815582-cfd2781336b6"
              alt="Flax agricultural production in Northern Kazakhstan"
              className="w-full h-[500px] object-cover shadow-2xl"
            />
            <div className="mt-6 text-center">
              <p className="text-sm text-gray-500 uppercase tracking-wider">Flax production in Northern Kazakhstan</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OriginSection;
